export default [
  {
    id: 'fixture',
    name: 'Fixtures',
  },
  {
    id: 'team-contact',
    name: 'Team Contacts',
  },
];
